
import React, { useRef, useState } from 'react';
import { Button, ImageUploader, NavBar, Slider } from 'antd-mobile'

import { 
    BodyView,
    ButtonView
} from "../../factory/ViewUtil";
import AvatarEditor from 'react-avatar-editor';
import { ToastClear, ToastContent, ToastLoading } from '../../factory/FactoryUtil';
import { updateCacheUserinfoAvatar, UpdateUserInfo } from '../../../NetworkFactory';


const MeEditAvatarViewController = ({goback}) => {
    const editor = useRef(null);
    const input = useRef(null)
    const [zoom, setZoom] = useState(1)
    const [base64, seBase64] = useState('')
    const setZoomValue = (val) => {
        setZoom(val/100)
    }

    const openPhoto = () => {
        const nativeInput = input.current?.nativeElement
        if (nativeInput) {
            nativeInput.click()
        }
    };
    const handerPhoto = (file) => {
        return new Promise(() => {
            const reader = new FileReader();
            reader.onload = (e) => {
               seBase64(e.target.result);
            };
            reader.readAsDataURL(file);
        });
    }

    const PostUpdate = () => {
        try {
            const cropBase64 = editor.current.getImageScaledToCanvas().toDataURL()
            if(cropBase64) {
                ToastLoading('Updating...')
                 const result = UpdateUserInfo(cropBase64, null)
                if(result === undefined) {
                    ToastClear()
                }
                else {
                    result.then(() => {
                        updateCacheUserinfoAvatar(cropBase64)
                        ToastContent('Upload success')
                        goback()
                    }).catch(() => {
                        ToastClear()
                    })
                }
            }
        } catch {
            ToastClear()
        }
        
    }

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>Edit Avatar</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <ImageUploader
                    ref={input}
                    accept = 'image/jpeg,image/jpg,image/png'
                    beforeUpload={handerPhoto}
                    maxCount={1} 
                    columns={0}
                    onPreview={false}
                    showUpload={false}
                    style={{display : 'none'}}
                />
                {
                    base64.length > 0 ? (<>
                    <div style={{height : '20px'}}></div>
                    <div style={{textAlign : 'center'}}>
                        <AvatarEditor
                            ref={editor}
                            image={base64}
                            width={250}
                            height={250}
                            borderRadius={1000}
                            border={10}
                            scale={zoom}
                            color={[255, 255, 255, 0.6]}
                            crossOrigin='anonymous'
                        />
                    </div>
                    <div style={{fontSize : '13px', color : '#999', marginTop : '20px', textAlign : "center"}}>
                        <div style={{margin : '10px 0'}}>Drag the slider to zoom in and out of the image</div>
                        <Slider min={100} max={500} 
                            onChange={(val) => {setZoomValue(val)}} 
                            icon={<div style={{
                                background : '#FFF',
                                width: '100%',
                                height : '100%',
                                display : 'flex',
                                alignItems : 'center',
                                justifyContent : 'center',
                                border: '2px #08BF89 solid',
                                borderRadius : '100px',
                                boxSizing : 'border-box'
                            }}></div>} 
                            style={{'--fill-color' : '#08BF89'}}/>
                    </div>
                    <ButtonView onClick={PostUpdate} style={{margin : '20px 0'}}>Update</ButtonView></>) : ''
                }
                <div style={{textAlign : 'center'}}>
                    <Button onClick={openPhoto} color='primary' fill='none' style={{fontSize : '15px'}}>Select file...</Button>
                </div>
            </BodyView>
        </>
    );
}
export default React.memo(MeEditAvatarViewController)